import { errorComponent } from './error.component';

export const errorStateName = 'app.error';

export const errorState = ($stateProvider) => {
  'ngInject';
  $stateProvider.state({
    name: errorStateName,
    url: '/error?id?requestId',
    params: {
      token: null,
    },
    component: errorComponent.name,
  });
};
